module.exports = __webpack_public_path__ + "media/flags/it-e3b5b571.svg";